var keydown_timeout;
var keydown_xhr;
var uploadedInitiated = false;


var jsFormId = '#form_fast_application';
var jsTheme = 'off';

function refreshTheme_form_fast_application() {
    if ( jsTheme == 'modern' ) {
        $( jsFormId + ' .afd-select-single option[value=""]' ).text( '' );
    }
}

function refreshFields_form_fast_application() {
    $( jsFormId + ' .afd-field' ).each( function () {

        if ( $( this ).hasClass( 'afd-field-multi' ) ) {
            if ( !$( this ).find( 'input:checked' ).length )
                $( this ).parents( '.afd-row' ).removeClass( 'afd-active' );
            else
                $( this ).parents( '.afd-row' ).addClass( 'afd-active' );
        } else {
            if ( !this.value )
                $( this ).parents( '.afd-row' ).removeClass( 'afd-active' );
            else
                $( this ).parents( '.afd-row' ).addClass( 'afd-active' );
        }
    } );
}

function refreshInputmask_form_fast_application() {
    $( jsFormId + ' [data-inputmask]' ).inputmask();
}

function autoresizeTextarea_form_fast_application() {
    $( jsFormId ).find( '[data-autoresize]' ).each( function () {
        var offset = this.offsetHeight - this.clientHeight;
        var resizeTextarea = function ( el ) {
            $( el ).css( 'height', 'auto' ).css( 'height', el.scrollHeight + offset );
        };
        $( this ).on( 'keyup input', function () {
            resizeTextarea( this );
        } ).removeAttr( 'data-autoresize' );
        resizeTextarea( this );
    } );
}

function refreshHL_form_fast_application() {

    $( jsFormId ).find( '.afd-hl-checkbox' ).each( function () {
        $( this ).find( '.afd-hl-item' ).on( 'click', function ( e ) {
            e.preventDefault();
            if ( !$( this ).is( '.afd-hl-active' ) ) {
                $( this ).addClass( 'afd-hl-active' ).find( ':checkbox' ).prop( 'checked', true );
            } else {
                $( this ).removeClass( 'afd-hl-active' ).find( ':checkbox' ).prop( 'checked', false );
            }
        } );
    } );

    $( jsFormId ).find( '.afd-hl-radio' ).each( function () {
        $( this ).find( '.afd-hl-item' ).on( 'click', function ( e ) {
            e.preventDefault();
            $( this ).addClass( 'afd-hl-active' ).siblings( 'div' ).removeClass( 'afd-hl-active' );
            $( this ).find( ':radio' ).prop( 'checked', true );
        } );
    } );
}

function initApplyForm() {    
   
        var jsSubmitText = 'Submit';
        var jsSubmitAjax = 'The application is sent...';
        $( jsFormId ).on( 'click change focus', '.afd-field', function () {

            refreshFields_form_fast_application();

            $( this ).parents( '.afd-row' ).addClass( 'afd-active' );
        } );

                //---------- Validation required fields ----------//
            $( jsFormId ).on( 'click change keyup', '.afd-row-required .afd-field', function () {

                if ( $( this ).hasClass( 'afd-field-multi' ) ) {
                    if ( !$( this ).find( 'input:checked' ).length )
                        $( this ).parents( '.afd-row' ).addClass( 'afd-row-danger' );
                    else
                        $( this ).parents( '.afd-row' ).removeClass( 'afd-row-danger' );
                } else {
                    if ( !this.value )
                        $( this ).parents( '.afd-row' ).addClass( 'afd-row-danger' );
                    else
                        $( this ).parents( '.afd-row' ).removeClass( 'afd-row-danger' );
                }

            } );
        
            //---------- Form submit action ----------//
            $('#form_fast_application' ).on( 'submit', function ( e ) {
                var _this = this;
                 e.preventDefault();
                 if (typeof (grecaptcha) !== 'undefined') {
                    grecaptcha.ready(function () {
                        grecaptcha.execute(RECAPTCHA_KEY, { action: 'submit' }).then(function (token) {
                             $('#form_fast_application').append('<input class="gr-recaptcha" name="g-recaptcha-response" type="hidden" value="'+token+'"/>');

                              var submitButton = $( _this ).find( '[type="submit"]' );
                                submitButton.prop( 'disabled', true ).find( 'span' ).html( jsSubmitAjax );
                                $.ajax( {
                                    data: $( _this ).serialize(),
                                    success: function ( data ) {
                                        submitButton.prop( 'disabled', false ).find( 'span' ).html( data.message );
                                        if(data['status']=='ok'){
                                           setTimeout(function () {
                                                window.location.reload();
                                            }, 2000);
                                        }else{
                                            submitButton.prop( 'disabled', false );
                                             if($('#form_fast_application').find('.gr-recaptcha').length>0 ){
                                                $('#form_fast_application').find('.gr-recaptcha').remove();
                                            }
                                        }
                                    },
                                        error: function (data) {
                                            submitButton.prop( 'disabled', false );
                                             if($('#form_fast_application').find('.gr-recaptcha').length>0 ){
                                                $('#form_fast_application').find('.gr-recaptcha').remove();
                                            }
                                        }
                                } );

                         });
                    });
                }
               
                return false;
            } );
       
}



function getHash() {
    var hash = window.location.hash;
    return hash.substring(2); // remove #!
}


function confirm_overwrite(message, callback) {
    var c = confirm(message);
    if (c) {
        callback();
    }
}

function confirmation(callback, id, message) {
    var c = confirm(message);
    if (c) {
        callback(id);
    }
}

function scroll2element(el) {
    var position = $(el).offset();
    var $padding = $body.css('paddingTop').replace('px','');
    var y = position.top - 200;
    $('html, body').stop().animate({scrollTop: y}, 'slow');
}


$(function(){

    /*$.validator.setDefaults({
        debug: false,
        errorPlacement: function(error, element) {
            error.hide();
        },
        highlight: function (element, errorClass, validClass) {
            $(element).parent().find('.form-control-feedback').remove();
            $(element).parent().append('<span class=" form-control-feedback"><i class="fa fa-times"></i></span>');
            $(element).parent().addClass('has-error has-feedback');
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).parent().find('.form-control-feedback').remove();
            $(element).parent().removeClass('has-error has-feedback');
        }
    });*/
});


function limitText(limitField, limitCount, limitNum) {
    if (limitField.value.length > limitNum) {
        limitField.value = limitField.value.substring(0, limitNum);
    } else {
        limitCount.html(limitNum - limitField.value.length);
    }
}

function isNumber(evt) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
    }
    return true;
}
function checkEmail(emailAddress) {
    var reValidEmail = new RegExp("^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$");

    return reValidEmail.test(emailAddress);
}